module.exports = __webpack_public_path__ + "img/banner3.cc97db43.png";